import { render, staticRenderFns } from "./HyroxScoreAdmin.vue?vue&type=template&id=68a1d64f&scoped=true"
import script from "./HyroxScoreAdmin.vue?vue&type=script&lang=js"
export * from "./HyroxScoreAdmin.vue?vue&type=script&lang=js"
import style0 from "./HyroxScoreAdmin.vue?vue&type=style&index=0&id=68a1d64f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1d64f",
  null
  
)

export default component.exports